<template>
  <div>
    <vs-row class="catBgClr mx-4">
      <vs-row>
        <h3 class="p-4 pb-4">Merchants</h3>
      </vs-row>

      <transition-group type="transition" name="flip-list" class="w-full">
        <vs-row
          :key="index"
          v-for="(category, index) in merchants"
          class="ml-5 mb-5"
        >
          <vs-col vs-lg="12" vs-sm="12" class="pr-6" id="inputBorder">
            <div class="my-2">
              <vs-row>
                <vs-col
                  vs-lg="5"
                  vs-sm="5"
                  class="inputContainer max-height-5-24"
                  vs-type="flex"
                  vs-justify="flex-start"
                >
                  Merchant {{ index + 1 }}
                </vs-col>
                <vs-col
                  vs-lg="7"
                  vs-sm="7"
                  class="inputContainer max-height-5-24 pr-3"
                  vs-type="flex"
                  vs-justify="flex-end"
                >
                  <vs-checkbox
                    v-model="merchants[index].isHidden"
                    vs-name="isHidden"
                    class=""
                    @input="
                      value => isHiddenFunc(merchants[index].isHidden, index)
                    "
                  />
                  <div class="addCardFont font-semibold ml-0 mb-0">
                    Hide from the list
                  </div>
                </vs-col>
              </vs-row>
            </div>
            <vs-input
              v-model="merchants[index].name"
              class="w-full py-3 pt-0"
              :disabled="true"
            />
          </vs-col>
        </vs-row>
      </transition-group>
      <vs-row v-if="errors.categories.success">
        <p class="text p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
      </vs-row>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="updateStatus.status"
      >
        <h5>{{ updateStatus.msg }}</h5>
      </vs-popup>
    </vs-row>
  </div>
</template>

<script>
import { PlusSquareIcon, MinusSquareIcon, MenuIcon } from "vue-feather-icons";
import draggable from "vuedraggable";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    MenuIcon,
    draggable
  },
  data() {
    return {
      merchants: [],
      remove_categories: [],

      errors: {
        categories: {
          msg: "",
          success: false
        },
        duplicateIndices: []
      },

      updateStatus: {
        msg: "",
        status: false
      },
      NoCategory: {
        msg: "",
        status: false
      },
      genericErrorMessage,
      toast
    };
  },
  methods: {
    isHiddenFunc(value, index) {
      this.$vs.loading({ background: "rgba(1,2,3,.2)" });
      this.$axios
        .patch(
          this.$ApiKeys.BASE_URL +
            this.$EndPoints.UpdateMerchantsStatus(this.merchants[index]._id),
          {
            status: value
          }
        )
        .then(res => {
          if (res.data.success) {
            this.toast("Merchant status updated successfully");
          }
          this.$vs.loading.close();
        })
        .catch(() => {
          this.toast(this.genericErrorMessage());
          this.$vs.loading.close();
        });
    },
    getMerchants() {
      this.$vs.loading({ background: "rgba(1,2,3,.2)" });
      this.$axios
        .get(this.$ApiKeys.BASE_URL + this.$EndPoints.FetchAllMerchants + '&showHidden=true')
        .then(res => {
          if (res.data.success) {
            this.merchants = res.data.data.merchants;
            this.$vs.loading.close();
          }
        })
        .catch(() => {
          this.toast(this.genericErrorMessage());
          this.$vs.loading.close();
        });
    }
  },
  created() {
    this.getMerchants();
  }
};
</script>

<style>
#inputBorder {
  cursor: grab;
}
#inputBorder input {
  border-color: #1c1c1e !important;
}

.whiteText {
  color: white !important;
}
.con-vs-tooltip {
  margin-top: 20px;
  margin-left: 10px;
  /* padding-top: 20px; */
  /* background: green; */
}
.catBgClr {
  background-color: #1c1c1e;
  padding: 20px;
  border-radius: 10px;
}
.cursor {
  cursor: pointer;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
}
.manageButton {
  width: 207px;
  border-radius: 10, 21, 10, 21;
  font-size: 13px;
  height: 45px;
}
@media only screen and (min-width: 800px) {
  .text {
    margin-left: 70px;
    padding-left: 30px;
  }
}
@media only screen and (max-width: 800px) {
  .text {
    margin-left: 30px;
    padding-left: 10px;
  }
}
</style>
